<template>
  <div class="tree-container">
    <v-card tile elevation="1" class="z-index-2">
      <v-toolbar flat dense color="white">
        <v-btn icon v-if="!$vuetify.breakpoint.mdAndUp" @click="drawerOpen = !drawerOpen">
          <v-icon>mdi-menu</v-icon>
        </v-btn>
      </v-toolbar>
    </v-card>
    <div class="content-container">
      <v-navigation-drawer
        v-model="drawerOpen"
        :permanent="$vuetify.breakpoint.mdAndUp"
        :absolute="!$vuetify.breakpoint.mdAndUp"
        :temporary="!$vuetify.breakpoint.mdAndUp"
        width="300"
        class="elevation-1"
        color="white"
      >
        <div class="pa-4">
          <div class="text-overline mb-2 primary--text font-weight-black">
            Explorar Planos
          </div>

          <v-divider class="mb-4"></v-divider>

          <div class="sidebar-scroll text-center">
              <PlanosLista
                :modo="1"
                :planosData="planosData"
                :planoSeleccionado="selectedPlano"
                @select="selectPlano"
                @plano-creado="fetchPlanos"
              />
            </div>
        </div>
      </v-navigation-drawer>  
     
      <div class="main-content">

        <Planos 
        :nodo="nodo" 
        :selectedPlano="selectedPlano" 
        :soloPlanos="true"
        @ir-a-subplano="onIrASubplano"
        @add-adjunto="$emit('add-adjunto', $event)"
        @ver-en-arbol="$emit('ver-en-arbol', $event)"
        @ver-en-plano="$emit('ver-en-plano', $event)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PlanosLista from "../utils/PlanosLista.vue";
import Planos from "./Planos.vue";
import axios from "axios";
import { jwtDecode } from "jwt-decode";

export default {
  name: "Armarios",
  components: { Planos, PlanosLista },
  props:{
    selectedPlano: Object,
    nodo:Object
  },
  data() {
    return {
      planosData: [],
      modoCrear: false,
      storageKey: 'plano-regiones',
      idCliente: null,
      drawerOpen: false,

    };
  },
  async mounted() {
    this.idCliente = localStorage.getItem("clienteSeleccionado") ? 
                      localStorage.getItem("clienteSeleccionado") : jwtDecode(localStorage.getItem("token")).id_cliente || 1;
    this.fetchPlanos();
  },
  methods: {
    async fetchPlanos() {
      try {
        const response = await axios.get(
          `/api/nodejs/planos`,{
          params: {
            id_cliente: this.idCliente
          }
        });
        console.log('planos',response)
        this.planosData = response.data || [];
      } catch (error) {
        console.error("Error al cargar planos", error);
      }
    },
    selectPlano(plano) {
      this.$emit('select',plano)
      // this.selectedPlano = plano;
    },
    onIrASubplano(payload) {
      const targetId = payload?.id;
      const planoDestino = this.planosData.find(
        (p) => String(p.id) === String(targetId)
      );

      if (planoDestino) {
        this.$emit("select", planoDestino);
      }

      this.$emit("ir-a-subplano", payload);
    },
  },
};
</script>

<style scoped>
.tree-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100vw;
}

.content-container {
  display: flex;
  flex-grow: 1;
  overflow: hidden;
}

.sidebar {
  padding: 16px;
  width: 20%;
  min-width: 250px;
  overflow-y: auto;
  border-right: 1px solid #ddd;
  flex-shrink: 0;
}

.main-content {
  width: 80%;
  min-width: 500px;
  padding: 16px;
  overflow-y: auto;
  flex-shrink: 0;
}
</style>
